import { Controller } from "@hotwired/stimulus";

// Manages the form distribution-lists index page (/forms/:id/lists). The page
// is server-rendered; this controller only handles the "+ Nouvelle liste"
// modal submit and per-row delete via the existing API endpoints. Successful
// mutations reload the page so server-rendered KPIs stay in sync.
export default class extends Controller {
  static targets = [
    "nameInput", "typeCard", "error"
  ];

  static values = {
    createUrl:               String,
    updateUrlTemplate:       String,
    csrfToken:               String
  };

  connect() {
    this._listType = "manual";
  }

  switchType(event) {
    const t = event.currentTarget.value;
    this._listType = t;
    this.typeCardTargets.forEach((card) => {
      card.classList.toggle("csm_mode-card--active", card.dataset.listType === t);
    });
    this._hideError();
  }

  async submitList(event) {
    event?.preventDefault?.();
    this._hideError();

    const name = (this.nameInputTarget?.value || "").trim();
    if (!name) {
      this._showError("Donne un nom à cette liste.");
      this.nameInputTarget?.focus();
      return;
    }

    try {
      const res = await fetch(this.createUrlValue, {
        method: "POST",
        headers: this._jsonHeaders(),
        credentials: "same-origin",
        body: JSON.stringify({
          jestionform_distribution_list: {
            name: name,
            list_type: this._listType || "manual"
          }
        })
      });
      if (!res.ok) {
        const err = await res.json().catch(() => ({}));
        throw new Error((err.errors || ["Création impossible"]).join(", "));
      }
      window.location.reload();
    } catch (e) {
      this._showError(e.message);
    }
  }

  async deleteList(event) {
    const id = event.currentTarget.dataset.listId;
    const name = event.currentTarget.dataset.listName || "cette liste";
    if (!id) return;
    if (!confirm(`Supprimer la liste « ${name} » ? Tous les destinataires et leurs réponses associés seront perdus.`)) return;

    const url = this.updateUrlTemplateValue.replace("__id__", id);
    try {
      const res = await fetch(url, {
        method: "DELETE",
        headers: this._jsonHeaders(),
        credentials: "same-origin"
      });
      if (!res.ok && res.status !== 204) {
        const err = await res.json().catch(() => ({}));
        throw new Error(err.error || "Suppression impossible.");
      }
      window.location.reload();
    } catch (e) {
      alert(e.message);
    }
  }

  // ── helpers ─────────────────────────────────────────────────────────

  _jsonHeaders() {
    return {
      "Content-Type": "application/json",
      "Accept": "application/json",
      "X-CSRF-Token": this.csrfTokenValue || (document.querySelector('meta[name="csrf-token"]')?.content || "")
    };
  }

  _showError(msg) {
    if (!this.hasErrorTarget) return;
    this.errorTarget.textContent = msg || "Une erreur est survenue.";
    this.errorTarget.hidden = false;
  }

  _hideError() {
    if (!this.hasErrorTarget) return;
    this.errorTarget.textContent = "";
    this.errorTarget.hidden = true;
  }
}
